import createExtendedPropertyRequestBody from '../utils/createExtendedPropertyRequestBody';
import datapoints from '../datapoints';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import { checkIfResponseSuccess } from 'owa-mail-store';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { DatapointStatus, returnTopExecutingActionDatapoint } from 'owa-analytics';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default createLegacyActionWithDatapoint(
    'storeTranslationData',
    datapoints.InlineTranslationStoreStatus
)(async function storeTranslationStatus(
    itemId: string,
    isShowingTranslation: boolean
): Promise<boolean> {
    const requestBody = createExtendedPropertyRequestBody(
        itemId,
        'TranslationStatus',
        `${isShowingTranslation}`
    );

    const dataPoint = returnTopExecutingActionDatapoint();
    return updateItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    })
        .then(response => {
            const success = checkIfResponseSuccess(response.Body.ResponseMessages.Items[0]);
            if (!success) {
                dataPoint.endWithError(DatapointStatus.ServerError);
            }
            return success;
        })
        .catch(error => {
            dataPoint.endWithError(DatapointStatus.ServerError);
            return false;
        });
});
